var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 12L6.78446 13.5689C7.04995 14.0999 7.18269 14.3654 7.36003 14.5954C7.51739 14.7996 7.70041 14.9826 7.90455 15.14C8.13462 15.3173 8.4001 15.4501 8.93108 15.7155L10.5 16.5L8.93108 17.2845C8.4001 17.5499 8.13462 17.6827 7.90455 17.86C7.70041 18.0174 7.51739 18.2004 7.36003 18.4046C7.18269 18.6346 7.04995 18.9001 6.78446 19.4311L6 21L5.21554 19.4311C4.95005 18.9001 4.81731 18.6346 4.63997 18.4046C4.48261 18.2004 4.29959 18.0174 4.09545 17.86C3.86538 17.6827 3.5999 17.5499 3.06892 17.2845L1.5 16.5L3.06892 15.7155C3.5999 15.4501 3.86538 15.3173 4.09545 15.14C4.29959 14.9826 4.48261 14.7996 4.63997 14.5954C4.81731 14.3654 4.95005 14.0999 5.21554 13.5689L6 12Z",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 1L15.6786 4.06442C15.9606 4.79765 16.1016 5.16426 16.3209 5.47264C16.5153 5.74595 16.754 5.98475 17.0274 6.17909C17.3357 6.39836 17.7024 6.53937 18.4356 6.82138L21.5 8L18.4356 9.17862C17.7024 9.46063 17.3357 9.60164 17.0274 9.82091C16.754 10.0153 16.5153 10.254 16.3209 10.5274C16.1016 10.8357 15.9606 11.2024 15.6786 11.9356L14.5 15L13.3214 11.9356C13.0394 11.2024 12.8984 10.8357 12.6791 10.5274C12.4847 10.254 12.246 10.0153 11.9726 9.82091C11.6643 9.60164 11.2976 9.46063 10.5644 9.17862L7.5 8L10.5644 6.82138C11.2976 6.53937 11.6643 6.39836 11.9726 6.17909C12.246 5.98475 12.4847 5.74595 12.6791 5.47264C12.8984 5.16426 13.0394 4.79765 13.3214 4.06442L14.5 1Z",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon2);
export default __webpack_public_path__ + "static/media/star-icon-2.311f1495383f8c0104d017fcf7fc06f1.svg";
export { ForwardRef as ReactComponent };